"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInputRange = require("react-input-range");

var _reactInputRange2 = _interopRequireDefault(_reactInputRange);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../../functions");

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _rangePropTypes = require("./rangePropTypes");

require("react-input-range/lib/css/index.css");

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Range = function (_Component) {
    _inherits(Range, _Component);

    function Range(props) {
        _classCallCheck(this, Range);

        var _this = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

        _this.state = {
            value: _this.props.value
        };
        return _this;
    }

    _createClass(Range, [{
        key: "handleChange",
        value: function handleChange(value) {
            this.setState({
                value: value
            });
            return this.props.onChange({
                name: this.props.name,
                value: value
            });
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                label = _props.label,
                name = _props.name,
                value = _props.value,
                onChange = _props.onChange,
                error = _props.error,
                rest = _objectWithoutProperties(_props, ["label", "name", "value", "onChange", "error"]);

            return _react2.default.createElement(
                "div",
                null,
                label && _react2.default.createElement(
                    _label2.default,
                    _extends({
                        style: { marginBottom: "15px" },
                        name: name,
                        label: label
                    }, this.props),
                    label
                ),
                this.props.easyRead && _react2.default.createElement(
                    "b",
                    null,
                    this.props.easyRead
                ),
                _react2.default.createElement(_reactInputRange2.default, _extends({
                    value: this.state.value,
                    onChange: this.handleChange.bind(this)
                }, rest)),
                _react2.default.createElement("br", null),
                _react2.default.createElement(_inputError2.default, { error: error })
            );
        }
    }]);

    return Range;
}(_react.Component);

Range.propTypes = {
    ariaLabelledby: _propTypes2.default.string,
    ariaControls: _propTypes2.default.string,
    classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
    disabled: _propTypes2.default.bool,
    draggableTrack: _propTypes2.default.bool,
    formatLabel: _propTypes2.default.func,
    label: _propTypes2.default.string,
    maxValue: _rangePropTypes.rangePropType,
    minValue: _rangePropTypes.rangePropType,
    name: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    onChangeStart: _propTypes2.default.func,
    onChangeComplete: _propTypes2.default.func,
    step: _propTypes2.default.number,
    value: _rangePropTypes.valuePropType,
    error: _propTypes2.default.string
};

Range.defaultProps = {
    error: ""
};

exports.default = Range;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/range.js
// module id = 1004
// module chunks = 95715928098905 168707334958949